import { AppRoutingConstants } from "../../app-routing.constants";
export class ApplicationSearchRoutingConstants {
    static APPLICATION_SEARCH_ROUTE = AppRoutingConstants.createRouteToView("application-search");
}
